import axios from "axios";
import { API } from "../config";

export const assignRoles = (payload) => async (_dispatch, getState) => {
    try {
        const {
            userLogin: { userInfo },
        } = getState();
        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`,
                'Content-Type': 'application/json',
            },
        };
        const { data } = await axios.post(`${API}/assign-roles`, payload, config);
        return data;
    } catch (error) {
        return { error: error.response?.data?.message || error.message };
    }
};
export const getRoleAndPermissionOptions = () => async (_dispatch, getState) => {
    try {
        const {
            userLogin: { userInfo },
        } = getState();
        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`,
                'Content-Type': 'application/json',
            },
        };
        const { data } = await axios.get(`${API}/users/options`, config);
        return data;
    } catch (error) {
        return { error: error.response?.data?.message || error.message };
    }
};